/**
 * Shared helpers for automotive panel widgets.
 */
export function lines(props, fallback) {
    var _a;
    return (_a = props.lines) !== null && _a !== void 0 ? _a : fallback;
}
